module.exports = __webpack_public_path__ + "img/16.1b0e6e22.jpg";